var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "appbar" }, [
    _c("div", { staticClass: "card-group" }, [
      _c("div", { staticClass: "card login" }, [
        _c(
          "div",
          { staticClass: "login--body" },
          [
            _c("h1", [_vm._v("Восстановление пароля")]),
            _c("span", { staticClass: "login__title" }, [
              _vm._v("Введите код восстановления"),
            ]),
            _c("span", { staticClass: "login__text" }, [
              _vm._v(
                "После отправки кода восстановления новый пароль будет отправлен на ваш email"
              ),
            ]),
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.model, rules: _vm.rules } },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "code" } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          placeholder: "Код восстановления",
                          "show-password": "",
                        },
                        model: {
                          value: _vm.model.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "code", $$v)
                          },
                          expression: "model.code",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-lock",
                          attrs: { slot: "prepend" },
                          slot: "prepend",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { loading: _vm.loading, type: "primary" },
                        on: { click: _vm.onSubmit },
                      },
                      [_vm._v("Отправить ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }